import React, { useEffect, useRef } from 'react';
import { ActionModalProps } from './action-modal.types';
import '@/assets/styles/components/action-modal.styles.scss';

export const ActionModal: React.FC<ActionModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	onSendMessage,
	isLoading = false,
	step = 'confirm',
	setSelectedDeleteReasonOption,
	selectedDeleteReasonOption,
	cancellationReason,
	setCancellationReason,
	contents
}) => {
	const modalRef = useRef<HTMLDivElement>(null);

	const currentContent = contents[step];

	const onSendForm = () => {
		if (step === 'confirm' || step === 'reasonInput') {
			onConfirm?.();
			return;
		}

		onSendMessage?.();
	};
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
				onClose();
			}
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [onClose]);

	if (!isOpen) return null;

	return (
		<div
			className={`action-modal ${step}`}
			ref={modalRef}
			onClick={e => e.stopPropagation()}>
			<div className="action-modal-header">
				<div className="action-modal-header-left">
					<i className={`icons-${step === 'success' || step === 'successExpertAppointmentDelete' ? 'check-circle' : 'close-circle'}`} />
					<div className={`action-modal-title action-modal-title-${step === 'success' || step === 'successExpertAppointmentDelete' ? 'success' : 'danger'}`}>{currentContent.title}</div>
				</div>
			</div>

			<div className="action-modal-content">
				{currentContent?.mainText && <p className="action-modal-text">{currentContent.mainText}</p>}

				{currentContent?.subText && <p className="action-modal-text">{currentContent.subText}</p>}

				{currentContent.options && currentContent.options.length > 0 && (
					<div className="cancellation-options">
						{currentContent.options.map((option, index) => (
							<div
								key={index}
								className={`cancellation-option ${selectedDeleteReasonOption === option?.value ? 'selected' : ''}`}
								onClick={() => {
									if (option?.value) {
										setSelectedDeleteReasonOption?.(option.value);
									}
								}}>
								<div className="option-radio">{selectedDeleteReasonOption === option?.value && <div className="option-radio-inner" />}</div>
								<span>{option?.label}</span>
							</div>
						))}
					</div>
				)}

				{step === 'reasonInput' && (
					<div className="cancellation-reason-input">
						<label htmlFor="cancellation-reason">İptal Sebebi</label>
						<textarea
							id="cancellation-reason"
							value={cancellationReason}
							onChange={e => setCancellationReason(e.target.value)}
							placeholder="Açıklamanızı yazabilirsiniz"
							rows={4}
						/>
					</div>
				)}
			</div>

			<div className="action-modal-footer">
				<button
					className="action-modal-button action-modal-button-secondary"
					onClick={e => {
						e.stopPropagation();
						onClose();
					}}>
					{currentContent.secondaryButton}
				</button>
				<button
					className={`action-modal-button action-modal-button-primary action-modal-button-${step === 'success' || step === 'successExpertAppointmentDelete' ? 'success' : 'danger'}`}
					onClick={onSendForm}
					disabled={isLoading || (step === 'confirm' && currentContent?.options?.length > 0 && !selectedDeleteReasonOption)}>
					{isLoading ? <span className="action-modal-loading"></span> : currentContent.primaryButton}
				</button>
			</div>
		</div>
	);
};

export default ActionModal;
